import { useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import AuthorizedCapitalModal from "./AuthorizedCapitalModal";
import IssuedCapitalModal from "./IssuedCapitalModal";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";


import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";



const ShareCapital = () => {

    const { irId } = useParams();
    const history = useHistory();


    const authorizedCapitalData = [
        {
            _id: "1",
            classOfShare: "Equity",
            numberOfShares: 1000,
            faceValue: 10,
            amount: 10000
        },
        {
            _id: "2",
            classOfShare: "Preference",
            numberOfShares: 500,
            faceValue: 100,
            amount: 50000
        },
        {
            _id: "3",
            classOfShare: "Right Issue",
            numberOfShares: 200,
            faceValue: 10,
            amount: 2000
        },
        {
            _id: "4",
            classOfShare: "Lease Leability",
            numberOfShares: 300,
            faceValue: 20,
            amount: 6000
        }
    ];

    const issuedCapitalData = [
        {
            _id: "1",
            shareHolder: "John Doe",
            relationship: "Director",
            classOfShare: "Equity",
            numberOfShares: 5000,
            faceValue: 10,
            amount: 50000,
            holding: "25",
        },
        {
            _id: "2",
            shareHolder: "Jane Smith",
            relationship: "Investor",
            classOfShare: "Preference",
            numberOfShares: 3000,
            faceValue: 10,
            amount: 30000,
            holding: "15",
        },
        {
            _id: "3",
            shareHolder: "ABC Holdings Pvt Ltd",
            relationship: "Promoter",
            classOfShare: "Equity",
            numberOfShares: 8000,
            faceValue: 10,
            amount: 80000,
            holding: "40",
        },
        {
            _id: "4",
            shareHolder: "Ravi Kumar",
            relationship: "Employee",
            classOfShare: "Right Issue",
            numberOfShares: 2000,
            faceValue: 10,
            amount: 20000,
            holding: "10",
        },
        {
            _id: "5",
            shareHolder: "XYZ Trust",
            relationship: "Affiliate",
            classOfShare: "Lease Liability",
            numberOfShares: 1000,
            faceValue: 10,
            amount: 10000,
            holding: "5",
        },
    ];

    const classOfShareOptions = ["Equity", "Preference", "Right Issue", "Lease Leability"]
    const relationshipOptions = ["Director","Investor","Promoter","Employee","Affiliate"]

    const [anchorEl, setAnchorEl] = useState(null);
    const [openAuthorizedCapitalPopoverId, setOpenAuthorizedCapitalPopoverId] = useState(null);
    const [selectedAuthorizedCapital, setSelectedAuthorizedCapital] = useState(null);
    const [authorizedModalOpen, setAuthorizedModalOpen] = useState(false)
    const [authorizedModalType, setAuthorizedModalType] = useState(null);
    const [issuedCapitalAnchorEl, setIssuedCapitalAnchorEl] = useState(null);
    const [openIssuedCapitalPopoverId, setOpenIssuedCapitalPopoverId] = useState(null);
    const [selectedIssuedCapital, setSelectedIssuedCapital] = useState(null);
    const [issuedCapitalModalOpen, setIssuedCapitalModalOpen] = useState(false)
    const [issuedCapitalModalType, setIssuedCapitalModalType] = useState(null);



    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenAuthorizedCapitalPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenAuthorizedCapitalPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedAuthorizedCapital(item); // store full row data
        setAuthorizedModalType("edit");
        setAuthorizedModalOpen(true); // open modal
        handleClose(); // close popover
    };


    const handleDelete = (id) => {
        console.log("Delete clicked for:", id);
        handleClose();
        // Add your delete logic here
    };

    const handleModalClose = () => {
        setAuthorizedModalOpen(false);
        setSelectedAuthorizedCapital(null);
        setAuthorizedModalType(null);
    };


    const handleAdd = () => {
        setSelectedAuthorizedCapital(null);
        setAuthorizedModalType("add");
        setAuthorizedModalOpen(true);
    };


    const handleIssuedCapitalPopoverClick = (event, id) => {
        setIssuedCapitalAnchorEl(event.currentTarget);
        setOpenIssuedCapitalPopoverId(id);
    };

    const handleIssuedCapitalPopoverClose = () => {
        setIssuedCapitalAnchorEl(null);
        setOpenIssuedCapitalPopoverId(null);
    };

    const handleIssuedCapitalEdit = (item) => {
        setIssuedCapitalModalType("edit");
        setSelectedIssuedCapital(item);
        setIssuedCapitalModalOpen(true);
        handleIssuedCapitalPopoverClose();
    };

    const handleIssuedCapitalDelete = (item) => {
        handleIssuedCapitalPopoverClose();
    };

    const handleAddIssuedCapital = () => {
        setSelectedIssuedCapital(null);
        setIssuedCapitalModalType("add");
        setIssuedCapitalModalOpen(true);
    };

    const handleIssuedCapitalModalClose = () => {
        setIssuedCapitalModalOpen(false);
        setSelectedIssuedCapital(null);
        setIssuedCapitalModalType(null);
    };


    const open = Boolean(anchorEl);


    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Share Capital"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRHeader}>
                        {/* <Button
                            btnColor={buttoncss.primary}
                            icon={<PlusIcon />}
                            label="Create Investment"
                            onClick={() => { history.push(`/create-investment/${irId}`) }}
                        /> */}
                    </div>

                    <div className={investmentRegisterCss.tableLayout}>
                        <div className={investmentRegisterCss.tableConatiner}>
                            <div className={investmentRegisterCss.tableTitle}>
                                <span>Authorized Capital</span>
                                <span>
                                    <Button
                                        btnColor={buttoncss.greyBg}
                                        icon={<PlusPrimaryIcon />}
                                        class_={investmentRegisterCss.addBtnRow}
                                        onClick={handleAdd}
                                    />
                                </span>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left", paddingLeft: "20px" }}>Class of share</th>
                                        <th style={{ textAlign: "right" }}>Number of shares</th>
                                        <th style={{ textAlign: "right" }}>Face value</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {authorizedCapitalData.map((item) => (
                                        <tr key={item._id}>
                                            <td style={{ textAlign: "left", paddingLeft: "20px" }}>{item.classOfShare}</td>
                                            <td style={{ textAlign: "right" }}>{item.numberOfShares}</td>
                                            <td style={{ textAlign: "right" }}>{item.faceValue}</td>
                                            <td style={{ textAlign: "right" }}>{item.amount}</td>
                                            <td>
                                                <MenuDotsIcon
                                                    style={{ cursor: "pointer", marginRight: 20 }}
                                                    onClick={(e) => handleMenuClick(e, item._id)}
                                                />
                                                <Popover
                                                    open={open && openAuthorizedCapitalPopoverId === item._id}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}

                                                >
                                                    <div className={investmentRegisterCss.irOptions}>
                                                        <span
                                                            style={{ borderBottom: "1px solid #EAEEED" }}
                                                            onClick={() => handleEdit(item)}
                                                        >
                                                            Edit
                                                        </span>
                                                        <span onClick={() => handleDelete(item._id)}>Delete</span>
                                                    </div>

                                                </Popover>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className={investmentRegisterCss.tableConatiner}>
                            <div className={investmentRegisterCss.tableTitle}>
                                <span>Issued Capital</span>
                                <span>
                                    <Button
                                        btnColor={buttoncss.greyBg}
                                        icon={<PlusPrimaryIcon />}
                                        class_={investmentRegisterCss.addBtnRow}
                                        onClick={handleAddIssuedCapital}
                                    />
                                </span>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left", paddingLeft: "20px" }}>Share holder</th>
                                        <th>Relationship</th>
                                        <th>Class of Share</th>
                                        <th style={{ textAlign: "right" }}>No of shares</th>
                                        <th style={{ textAlign: "right" }}>Face value</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        <th style={{ textAlign: "right" }}>Holding</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {issuedCapitalData.map((item) => (
                                        <tr key={item._id}>
                                            <td style={{ textAlign: "left", paddingLeft: "20px" }}>{item.shareHolder}</td>
                                            <td>{item.relationship}</td>
                                            <td>{item.classOfShare}</td>
                                            <td style={{ textAlign: "right" }}>{item.numberOfShares}</td>
                                            <td style={{ textAlign: "right" }}>{item.faceValue}</td>
                                            <td style={{ textAlign: "right" }}>{item.amount}</td>
                                            <td style={{ textAlign: "right" }}>{item.holding}</td>
                                            <td>
                                                <MenuDotsIcon
                                                    style={{ cursor: "pointer" }}
                                                    onClick={(e) => handleIssuedCapitalPopoverClick(e, item._id)}
                                                />
                                                <Popover
                                                    open={openIssuedCapitalPopoverId === item._id}
                                                    anchorEl={issuedCapitalAnchorEl}
                                                    onClose={handleIssuedCapitalPopoverClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}

                                                >
                                                    <div className={investmentRegisterCss.irOptions}>
                                                        <span
                                                            style={{ borderBottom: "1px solid #EAEEED" }}
                                                            onClick={() => handleIssuedCapitalEdit(item)}
                                                        >
                                                            Edit
                                                        </span>
                                                        <span onClick={() => handleIssuedCapitalDelete(item)}>Delete</span>
                                                    </div>

                                                </Popover>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </motion.div>
            </div>

            {authorizedModalOpen && (
                <AuthorizedCapitalModal
                    handleClose={handleModalClose}
                    data={selectedAuthorizedCapital}
                    type={authorizedModalType}
                    classOfShareOptions={classOfShareOptions}
                />
            )}

            {issuedCapitalModalOpen && (
                <IssuedCapitalModal
                    handleClose={handleIssuedCapitalModalClose}
                    data={selectedIssuedCapital}
                    type={issuedCapitalModalType}
                    classOfShareOptions={classOfShareOptions}
                    relationshipOptions={relationshipOptions}
                />
            )}

        </>
    )
}

export default ShareCapital;